import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, exhaustMap, filter, map, merge, of, withLatestFrom } from 'rxjs';
import { UserConfigService } from 'src/app/services/utility/user-config.service';
import { MENU_STATE_KEY } from '../side-menu.service';
import { MenuState } from '../side-menu.types';
import { SideMenuStateActions } from './side-menu-state.actions';
import { selectMenuState } from './side-menu-state.reducer';

export const getMenuState$ = createEffect(
  (actions$ = inject(Actions), userConfigService = inject(UserConfigService)) =>
    actions$.pipe(
      ofType(SideMenuStateActions.getMenuState),
      exhaustMap(() =>
        userConfigService.getSingle<MenuState>(MENU_STATE_KEY).pipe(
          map(menuState => SideMenuStateActions.getMenuStateSuccess({ menuState })),
          catchError((err: unknown) => of(SideMenuStateActions.getMenuStateFailure({ error: String(err) })))
        )
      )
    ),
  { functional: true }
);

export const saveMenuState$ = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store),
    userConfigService = inject(UserConfigService),
    oidcService = inject(OidcSecurityService)
  ) =>
    merge(
      actions$.pipe(ofType(SideMenuStateActions.saveMenuState)),
      actions$.pipe(ofType(SideMenuStateActions.setHorizontalExpanded))
    ).pipe(
      withLatestFrom(store.select(selectMenuState), oidcService.isAuthenticated$),
      filter(([_, _menuState, { isAuthenticated }]) => isAuthenticated),
      exhaustMap(([_, menuState]) =>
        userConfigService.saveDirect(MENU_STATE_KEY, menuState).pipe(
          map(() => SideMenuStateActions.saveMenuStateSuccess()),
          catchError((err: unknown) => of(SideMenuStateActions.saveMenuStateFailure({ error: String(err) })))
        )
      )
    ),
  { functional: true }
);
